{
  "version": 1,
  "asset_id": "001fedb5-720c-4826-a062-2e3f81908d7e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/001fedb5-720c-4826-a062-2e3f81908d7e/sleeve-fitzer-3-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/001fedb5-720c-4826-a062-2e3f81908d7e/sleeve-fitzer-3-440.webp",
  "original_filename": "sleeve-fitzer-3-440.webp",
  "size": 7496,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:30Z"
}
